import {
  SocialAccount, Post, PostNote, User, UserClient, Client,
} from '@/type';
import { Person } from '@/analysis/types';

export class ClientStarred {
  static eventName = 'client.starred';
}

export class ClientUnstarred {
  static eventName = 'client.unstarred';
}

export class ClientEdited {
  static eventName = 'client.edited';

  client: Client;

  constructor(client: Client) {
    this.client = client;
  }
}

export class ClientDeleted {
  static eventName = 'client.deleted';

  clientId: number;

  constructor(clientId: number) {
    this.clientId = clientId;
  }
}

export class UserAssignedToClient {
  static eventName = 'user.assigned_to_client';

  userClient: UserClient;

  constructor(userClient: UserClient) {
    this.userClient = userClient;
  }
}

export class UserUnassignedFromClient {
  static eventName = 'user.unassigned_from_client';

  userClient: UserClient;

  constructor(userClient: UserClient) {
    this.userClient = userClient;
  }
}

export class ClientAssignedToUser {
  static eventName = 'client.assigned_to_user';

  user: User;

  constructor(user: User) {
    this.user = user;
  }
}

export class ClientUnassignedFromUser {
  static eventName = 'client.unassigned_from_user';

  userClient: UserClient;

  constructor(userClient: UserClient) {
    this.userClient = userClient;
  }
}

export class SocialAccountDeleted {
  static eventName = 'social_account.deleted';

  socialAccount: SocialAccount;

  constructor(socialAccount: SocialAccount) {
    this.socialAccount = socialAccount;
  }
}

export class PostEvent {
  post: Post;

  constructor(post: Post) {
    this.post = post;
  }
}

export class PostSaved extends PostEvent {
  static eventName = 'post.saved';
}

export class PostEscalated extends PostEvent {
  static eventName = 'post.escalated';

  oldPost: Post;

  constructor(post: Post, oldPost: Post) {
    super(post);
    this.oldPost = oldPost;
  }
}

export class PostResolved extends PostEvent {
  static eventName = 'post.resolved';
}

export class PostTrashed extends PostEvent {
  static eventName = 'post.trashed';
}

export class PostMovedToTimeline extends PostEvent {
  static eventName = 'post.moved_to_timeline';
}

export class PostRemovedFromTimeline extends PostEvent {
  static eventName = 'post.removed_from_timeline';
}

export class PostRestored extends PostEvent {
  static eventName = 'post.restored';
}

export class PostNoteAdded {
  static eventName = 'post.note_added';

  note: PostNote;

  constructor(postNote: PostNote) {
    this.note = postNote;
  }
}

export abstract class PersonEvent {
  person: Person;

  constructor(person: Person) {
    this.person = person;
  }

  get clientId(): number {
    return this.person.clientId;
  }
}

export class PersonCreated extends PersonEvent {
  static eventName = 'person.created';
}

export class PersonMerged extends PersonEvent {
  static eventName = 'person.merged';

  sourcePersonIds: number[];

  constructor(person: Person, sourcePersonIds: number[]) {
    super(person);
    this.sourcePersonIds = sourcePersonIds;
  }
}

export class PersonTrashed extends PersonEvent {
  static eventName = 'person.trashed';
}

export class PersonRestored extends PersonEvent {
  static eventName = 'person.restored';
}

export class ReportGenerated {
  static eventName = 'report.generated';

  id: number;

  constructor(id: number) {
    this.id = id;
  }
}

export class ReportDeleted {
  static eventName = 'report.deleted';

  id: number;

  constructor(id: number) {
    this.id = id;
  }
}

export class ReportPostCommentEdited {
  static eventName = 'report_post.comment_edited';
}
